import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-mini-progress-spinner',
  templateUrl: './mini-progress-spinner.component.html',
  styleUrls: ['./mini-progress-spinner.component.scss']
})
export class MiniProgressSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
